import { Utils } from 'versafleet-core';

const { Helper, ReduxHelper } = Utils;

const initialState = {
  timestamp: null,
  archivedTimestamp: null,
  tasks: {},
  tasksIds: [],
  archivedTaskIds: [],
  taskMeta: {},
  archivedTaskMeta: {},
  filter: {},
  error: {},
  isAddingTag: false,
  isValidated: false,
  isDeleting: false,
  isDeletingMultiple: false,
  totalFailedTasksCount: 0,
  failedTasks: [],
  taskCount: null,
  exportTags: [],
  systemTags: {},
  optionAddresses: [],
};

function task(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_TASK':
      return {
        ...state,
        tasks: ReduxHelper.mergeDataWithObject(state.tasks, action.task),
      };
    case 'RECEIVE_TASKS':
      if (Helper.isNullOrUndefined(state.timestamp) || state.timestamp < action.timestamp) {
        return {
          ...state,
          tasksIds: action.tasks.map(t => t.id),
          tasks: ReduxHelper.mergeDataWithList(state.tasks, action.tasks),
          taskMeta: action.meta,
          timestamp: action.timestamp,
        };
      }
      return state;
    case 'RECEIVE_TASKS_DETAILS': {
      // Event can be triggered by fetching of task completion histories to display
      // task success/failure notes if it is configured to be shown in the custom layout).
      return {
        ...state,
        tasks: ReduxHelper.mergeDataWithList(state.tasks, action.tasks),
      };
    }
    case 'RECEIVE_ARCHIVED_TASKS':
      if (Helper.isNullOrUndefined(state.archivedTimestamp)
        || state.archivedTimestamp < action.timestamp) {
        return {
          ...state,
          archivedTaskIds: action.tasks.map(t => t.id),
          tasks: ReduxHelper.mergeDataWithList(state.tasks, action.tasks),
          archivedTaskMeta: action.meta,
          archivedTimestamp: action.timestamp,
        };
      }
      return state;
    case 'REQUEST_ADDING_TAG':
      return {
        ...state,
        isAddingTag: true,
      };
    case 'RECEIVE_ADDING_TAG':
      return {
        ...state,
        isAddingTag: false,
      };
    case 'RECEIVE_TASK_UPDATE_SUCCESSFUL':
      return {
        ...state,
        tasks: ReduxHelper.mergeDataWithObject(state.tasks, action.task),
      };
    case 'SET_TASK_FILTER':
      return {
        ...state,
        filter: action.filter || state.filter,
      };
    case 'RECEIVE_TOTAL_FAILED_TASKS_COUNT':
      return {
        ...state,
        totalFailedTasksCount: action.count,
      };
    case 'RECEIVE_FAILED_TASKS':
      return {
        ...state,
        failedTasks: action.failedTasks,
      };
    case 'RECEIVE_EXPORT_TAGS':
      return {
        ...state,
        exportTags: action.exportTags,
      };
    case 'RECEIVE_TASK_EXPORT_SUCCESSFUL':
      return {
        ...state,
        error: {},
        isUpdating: false,
      };
    case 'RECEIVE_EXPORT_TASK_COUNT_SUCCESSFUL':
      return {
        ...state,
        taskCount: action.taskCount,
        error: {},
        isUpdating: false,
      };
    case 'RECEIVE_RESET_EXPORT_TASK_COUNT':
      return {
        ...state,
        taskCount: null,
      };
    case 'REQUEST_TASK_DELETE':
      return {
        ...state,
        isDeleting: true,
      };
    case 'RECEIVE_TASK_DELETE_SUCCESSFUL':
      return {
        ...state,
        isDeleting: false,
      };
    case 'RECEIVE_TASK_DELETE_FAILED':
      return {
        ...state,
        error: action.error,
        isDeleting: false,
      };
    case 'REQUEST_TASK_MULTIPLE_DELETE':
      return {
        ...state,
        isDeletingMultiple: true,
      };
    case 'RECEIVE_TASK_MULTIPLE_DELETE_SUCCESSFUL':
      return {
        ...state,
        isDeletingMultiple: false,
      };
    case 'RECEIVE_TASK_MULTIPLE_DELETE_FAILED':
      return {
        ...state,
        error: action.error,
        isDeletingMultiple: false,
      };
    case 'RECEIVE_SYSTEM_TAGS':
      return {
        ...state,
        systemTags: action.systemTags,
      };
    case 'RECEIVE_OPTION_ADDRESSES':
      return {
        ...state,
        optionAddresses: action.optionAddresses,
      };
    default:
      return state;
  }
}

export default task;
